import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
// import Vue from 'vue'

export default class FavoritesApi {
  constructor() {}
  
  async addToFavorite(appId) {
    let addToFavorites = await import('./graphql/favoriteLists/addToFavorite.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${addToFavorites}`,
        variables: {appId}
      })
      .then(res =>  res.data.addApplicationToFavourite) 
      // .catch(error => Vue.prototype.$log_error(error.message))
  }


  async deleteItem(appId) {
    let deleteFavItem = await import('./graphql/favoriteLists/deleteFavItem.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${deleteFavItem}`,
        variables: {appId}, 
      })
      .then(res => res.data.deleteApplicationFromFavorites) 
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

}